import {
  PURCHASE_POINTS_BREADCRUMB_LABELS,
  PURCHASE_POINTS_BRANDS_PATH,
  PURCHASE_POINTS_PATH,
} from "@/features/purchasePoints/config/purchasePoints.config";
import type { BreadcrumbItem } from "@/shared/components/breadcrumb";

/**
 * Each page sits at the same place whatever the way the employee took to it:
 * the trail follows the URL, never the history.
 */
const YEATIES_CRUMB: BreadcrumbItem = { label: PURCHASE_POINTS_BREADCRUMB_LABELS.yeaties, to: PURCHASE_POINTS_PATH };
const BRANDS_CRUMB: BreadcrumbItem = { label: PURCHASE_POINTS_BREADCRUMB_LABELS.brands, to: PURCHASE_POINTS_BRANDS_PATH };
const OFFER_CRUMB: BreadcrumbItem = { label: PURCHASE_POINTS_BREADCRUMB_LABELS.offer };

// The page being read closes the trail, unlinked.
export const buildYeatiesBreadcrumb = (): BreadcrumbItem[] => [{ label: PURCHASE_POINTS_BREADCRUMB_LABELS.yeaties }];

export const buildBrandsBreadcrumb = (): BreadcrumbItem[] => [
  YEATIES_CRUMB,
  { label: PURCHASE_POINTS_BREADCRUMB_LABELS.brands },
];

export const buildBrandBreadcrumb = (brandName: string): BreadcrumbItem[] => [
  YEATIES_CRUMB,
  BRANDS_CRUMB,
  { label: brandName },
];

type OfferBreadcrumbOptions = {
  brandName: string
  // null leaves the brand unlinked: a single-offer brand page redirects to
  // the very offer the employee is reading.
  brandPath: string | null
};

export const buildOfferBreadcrumb = ({ brandName, brandPath }: OfferBreadcrumbOptions): BreadcrumbItem[] => [
  YEATIES_CRUMB,
  BRANDS_CRUMB,
  brandPath ? { label: brandName, to: brandPath } : { label: brandName },
  OFFER_CRUMB,
];
